// extracted by mini-css-extract-plugin
export default {"projectLink":"ProjectLink_projectLink__vSa0A","projectLinkContainer":"ProjectLink_projectLinkContainer__j9Jry","logo":"ProjectLink_logo__9hnHg"};